import * as classNames from 'classnames';
import { i18n } from '../../../../i18n/i18n';
import { i18nLang } from '../../../../i18n/i18nLang';
import * as React from 'react';
import Select from 'react-select';
import style from './LanguageSelect.less';
import { WFormFieldSelectOption } from '../../../../core/forms/fields/WFormFieldSelect';

interface LanguageSelectProps extends React.ClassAttributes<any> {
    disabled?: boolean;
    label?: string;
    onChange: (data: string) => void;
    value: string;
}

export class LanguageSelect extends React.Component<LanguageSelectProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.init();
    }

    private languages: any = {
        de: i18n('Deutsch', 'sys'),
        en: i18n('Englisch', 'sys'),
        fr: i18n('Französisch', 'sys'),
        es: i18n('Spanisch', 'sys'),
        lb: i18n('Luxemburgisch', 'sys')
    };
    private options: any[];

    getSelectedValue(): any {
        return this.options.find((option: any) => option.value === this.props.value);
    }

    getStyle(current: React.CSSProperties, custom?: React.CSSProperties): React.CSSProperties {
        return {
            ...(current || {}),
            minHeight: 1,
            height: 30,
            padding: '0 5px',
            ...(custom || {})
        };
    }

    init(): void {
        this.options = (i18nLang.languages || []).map((language: string, index: number) => {
            const option: WFormFieldSelectOption = {
                index,
                value: language,
                label: <div className={classNames(style.flag, style[`flag-${language}`])}>
                    {this.languages[language]}
                </div>
            };
            return option;
        });
    }

    render(): JSX.Element {
        return (
            <div className={style.wrapper}>
                {this.props.label &&
                    <div className={style.label}>
                        {this.props.label}
                    </div>
                }
                <div className={style.select}>
                    <Select
                        placeholder={i18n('keine Auswahl', 'sys')}
                        options={this.options}
                        value={this.getSelectedValue()}
                        disabled={this.props.disabled}
                        onChange={(event: any) => this.props.onChange(event.value)}
                        styles={{
                            option: (provided: any) => this.getStyle(provided, { padding: 5, height: '100%' }),
                            control: (provided: any) => this.getStyle(provided),
                            valueContainer: (provided: any) => this.getStyle(provided),
                            indicatorsContainer: (provided: any) => this.getStyle(provided, { width: 30 })
                        }}
                    />
                </div>
            </div>
        );
    }
}
